module.exports = __webpack_public_path__ + "img/Jack.87a79d5a.jpg";